import { RaiffeisenImpulsDeLogo } from "@App/Components/atoms/whitelabel/logos/RaiffeisenImpulsDeLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Raiffeisen-IMPULS (DE) whitelabel.
 * Extends the default configuration with specific settings for Raiffeisen-IMPULS (DE).
 */
export const config: Partial<Config> = {
  slug: "raiffeisen-impuls-de",
  navbar: {
    logos: {
      right: {
        component: <RaiffeisenImpulsDeLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
  },
  reviews: {
    show: true,
  },
  homeSections: {
    image: { src: "/images/partner/raiffeisen/raiffeisen_list_items.webp", alt: "Raiffeisen" },
  },
};

export default config;
